import React from "react";
import {
  Box,
  Tabs,
  Tab,
  Stack,
  Slide,
  Typography,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Images } from "./../../assets/common";
import PageHeader from "../../components/PageHeader";
import FollowRow from "../../components/FollowRow";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import {
  fullName,
  getErrorString,
  getUserDetail,
} from "./../../constants/function";
import NoData from "../../components/Nodata";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Follow() {
  const history = useHistory();
  const { t } = useTranslation("common");
  const [loaded, setLoaded] = React.useState(false);
  const [fLoaded, setFLoaded] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(1);
  const [fPageNo, setFPageNo] = React.useState(1);
  const state = useLocation();
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [followerList, setFollowerList] = React.useState([]);
  const [followingList, setFollowingList] = React.useState([]);
  const userDetails = getUserDetail();
  const [followerCount, setFollowerCount] = React.useState(0);
  const [followingCount, setFollowingCount] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPageNo(1); //resetting the pageno to 1 whenever tab changes
    setFPageNo(1); //resetting the pageno to 1 whenever tab changes
    switch (newValue) {
      case 0:
        setFollowingList([]);
        // getFollowerList(id ? id : userDetails["_id"], 1);
        history.push(`/app/Follow/${id}`);
        break;
      case 1:
        setFollowerList([]);
        // getFollowingList(id ? id : userDetails["_id"], 1);
        history.push(`/app/Following/${id}`);
        break;
    }
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getFollowerList = async (id, next) => {
    try {
      setLoading(true);
      const response = await ApiService.FOLLOWERLIST(
        `${id}&pageNo=${next}&pageSize=15`
      );

      setFollowerList([...followerList, ...response["result"]]);
      setFLoaded(response["result"].length < 15 ? true : false);
      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  const getFollowingList = async (id, next) => {
    try {
      setLoading(true);
      const response = await ApiService.FOLLOWINGLIST(
        `${id}&pageNo=${next}&pageSize=15`
      );

      setFollowingList([...followingList, ...response["result"]]);
      setLoaded(response["result"].length < 15 ? true : false);
      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  const handleFollowClick = (isFollower, isFollowed, index) => {
    if (isFollower) {
      const follow = followerList;
      follow[index]["isFollowed"] = isFollowed;
      setFollowerList([...follow]);
    } else {
      const following = followingList;
      following[index]["isFollowed"] = isFollowed;
      setFollowingList([...following]);
    }
  };
  React.useEffect(() => {
    if (window.location.href.includes("Following") && userDetails && id) {
      setValue(1);
      getFollowingList(id ? id : userDetails["_id"], 1);
      getProfileDetail(id ? id : userDetails["_id"]);
    } else if (window.location.href.includes("Follow") && userDetails && id) {
      setValue(0);
      getFollowerList(id ? id : userDetails["_id"], 1);
      getProfileDetail(id ? id : userDetails["_id"]);
      // getFollowingList(id ? id : userDetails["_id"], 1);
    }
  }, [state.pathname]);

  const getProfileDetail = async (id) => {
    const response = await ApiService.USER_DETAILS(id);
    setFollowerCount(response["result"]["followerCount"]);
    setFollowingCount(response["result"]["followingCount"]);
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;
    //(a);
    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getFollowingList(id ? id : userDetails["_id"], next);
    }
  };
  const handleFScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;
    //console.log(a);
    if ((a / b) * 100 > 80 && !loading && !fLoaded) {
      // run a function called doSomething
      const next = fPageNo + 1;
      setFPageNo(next);
      getFollowerList(id ? id : userDetails["_id"], next);
    }
  };

  return (
    <Box sx={{ padding: "0 22px" }}>
      <PageHeader
      // isVerified={
      //   state && state["state"] && state["state"]["userData"]
      //     ? state &&
      //       state["state"] &&
      //       state["state"]["userData"]["isVerified"]
      //     : userDetails["isVerified"]
      // }
      // title={
      //   state && state["state"] && state["state"]["userData"]
      //     ? fullName(state["state"]["userData"])
      //     : fullName(userDetails)
      // }
      // search={true}
      />
      <Box
        sx={{
          height: "inherit",
          // backgroundColor: "#262626",
          backgroundColor: "#090909",
          position: "relative",
        }}
        className="__follow_container"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab
            label={`${followerCount} ${t("follow.tabs.tab1")}`}
            {...a11yProps(0)}
          />
          <Tab
            label={`${followingCount} ${t("follow.tabs.tab2")}`}
            {...a11yProps(1)}
          />
        </Tabs>

        <Box
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          // sx={{ maxHeight: "77vh", overflow: "scroll" }}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box className="__sub_padding" sx={{ position: "relative" }}>
              <Stack
                spacing={1}
                sx={{ height: "calc(100vh - 200px)", overflow: "scroll" }}
                onScroll={(e) => handleFScroll(e.target)}
              >
                {followerList.length > 0 ? (
                  followerList.map((follow, index) => (
                    <FollowRow
                      onHandleFollow={handleFollowClick}
                      index={index}
                      key={index}
                      follow={follow}
                      user={follow["follower"]}
                      isFollow={follow["isFollowed"]}
                      isFollower={true}
                      userId={userDetails["_id"]}
                    />
                  ))
                ) : (
                  <NoData lable={t("noData.message11")} />
                )}
              </Stack>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Box className="__sub_padding" sx={{ position: "relative" }}>
              <Stack
                spacing={1}
                sx={{ height: "calc(100vh - 200px)", overflow: "scroll" }}
                onScroll={(e) => handleScroll(e.target)}
              >
                {followingList.length > 0 ? (
                  followingList.map((follow, index) => (
                    <FollowRow
                      onHandleFollow={handleFollowClick}
                      index={index}
                      key={index}
                      follow={follow}
                      user={follow["following"]}
                      isFollow={follow["isFollowed"]}
                      isFollowing={true}
                      userId={userDetails["_id"]}
                    />
                  ))
                ) : (
                  <NoData lable={t("noData.message12")} />
                )}
              </Stack>
            </Box>
          </TabPanel>
        </Box>
        {loading ? <Loader wait={true} _class="__loader_inside" /> : null}
      </Box>
    </Box>
  );
}
